module.exports = __webpack_public_path__ + "static/img/vendor-register.b0b0f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/vendor-register.jpg
// module id = oJao
// module chunks = 1